export * from './allowed-origins.js';
export * from './status-mapping.js';
export * from './feedback-status.js';
export * from './founder-category.js';
export * from './coaching-call-occurrences.js';
export * from './coaching-call-edit.js';
export * from './calls.js';
export * from './http-header-value.js';
export * from './labels.js';
export * from './markdown-text.js';
export * from './engagement-timeline.js';
export * from './zone-time.js';
export * from './shift-days.js';
export * from './activity-search.js';
export * from './activity-domain.js';
export * from './os-account-status.js';
export * from './activity-classification.js';
export { deriveActivitySummaryFlags } from './activity-summary.js';
export * from './productivity-trend.js';
export * from './activtrak-classifications.js';
export * from './sprout-shift-time.js';
// `write-if-changed` is a Node-only helper (uses `node:fs`). Import it
// directly from `@doneverse/shared/utils/write-if-changed.js` if you need it.
// Re-exporting it here pulled `node:fs` into the dashboard bundle and broke
// the Vite build.
export function formatDate(date) {
    return date.toISOString().split('T')[0];
}
export function slugify(text) {
    return text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
/**
 * The suffix appended to a ClickUp task name for a given playbook run
 * (restart feature, ClickUp 86d3nhbbh).
 *
 * Run 1 gets NO suffix, so existing task names stay byte-identical and the doing
 * teams see no change. Later runs get " #N", which the caller places BEFORE
 * " - Founder:" so harvest-brief's gate regex and parseTaskName keep matching.
 */
export function instanceTaskSuffix(runNumber) {
    return Number.isFinite(runNumber) && runNumber > 1 ? ` #${runNumber}` : '';
}
/**
 * Project a prior run's brief answers onto a new run.
 *
 * A brief is jsonb keyed by field_id: `{ field_id: { answer, choices? } }`. When
 * a founder starts a new run "as a copy" of a prior one, carry over only the
 * answers whose field_id still exists in the target playbook's schema — so a
 * schema change, or a copy from a *different* playbook, cannot inject stale or
 * foreign keys. Returns a new object; the source is not mutated.
 */
export function projectBriefAnswers(source, targetFieldIds) {
    const allowed = new Set(targetFieldIds);
    const result = {};
    for (const [fieldId, value] of Object.entries(source)) {
        if (allowed.has(fieldId))
            result[fieldId] = value;
    }
    return result;
}
/**
 * A copy of `list` with the items at `a` and `b` exchanged.
 *
 * For arrow-button reordering (CMS steps, additional videos), where the caller
 * wants a new array to hand straight to `onChange` or a mutation. Written by
 * hand it is a destructuring swap that reads like a typo; named, it does not.
 *
 * Bounds are the caller's business — they already know whether the move is
 * legal, and firing a no-op save is worse than not moving.
 */
export function swapAt(list, a, b) {
    const next = [...list];
    [next[a], next[b]] = [next[b], next[a]];
    return next;
}
//# sourceMappingURL=index.js.map